"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_1 = require("mobx");

var reactive_localstorage_1 = require("reactive-localstorage");

var referenceEnhancer = mobx_1.observable.map({}, {
  deep: false
}).enhancer;

var LocalStorage =
/** @class */
function (_super) {
  __extends(LocalStorage, _super);

  function LocalStorage() {
    var _this = _super.call(this, undefined, referenceEnhancer, 'LocalStorage') || this;

    var len = reactive_localstorage_1.default.length;

    for (var i = 0; i < len; i++) {
      var key = reactive_localstorage_1.default.key(i);
      var value = parseValue(reactive_localstorage_1.default.getItem(key));

      _super.prototype.set.call(_this, key, value);
    }

    reactive_localstorage_1.default.on('change', function (key, value) {
      if (typeof value === 'string') {
        _super.prototype.set.call(_this, key, parseValue(value));
      } else {
        _super.prototype.delete.call(_this, key);
      }
    });
    return _this;
  }

  Object.defineProperty(LocalStorage.prototype, "length", {
    get: function get() {
      return this.size;
    },
    enumerable: true,
    configurable: true
  });

  LocalStorage.prototype.key = function (index) {
    return reactive_localstorage_1.default.key(index);
  };

  LocalStorage.prototype.getItem = function (key) {
    return _super.prototype.has.call(this, key) ? _super.prototype.get.call(this, key) : null;
  };

  LocalStorage.prototype.setItem = function (key, value) {
    this.set(key, value);
  };

  LocalStorage.prototype.removeItem = function (key) {
    return _super.prototype.delete.call(this, key);
  };

  LocalStorage.prototype.clear = function () {
    reactive_localstorage_1.default.clear();

    _super.prototype.clear.call(this);
  };

  LocalStorage.prototype.set = function (key, value) {
    reactive_localstorage_1.default.setItem(key, JSON.stringify(mobx_1.toJS(value)));
    return this;
  };

  LocalStorage.prototype.delete = function (key) {
    var has = _super.prototype.has.call(this, key);

    reactive_localstorage_1.default.removeItem(key);
    return has;
  };

  return LocalStorage;
}(mobx_1.ObservableMap);

exports.LocalStorage = LocalStorage;

function parseValue(value) {
  try {
    return JSON.parse(value);
  } catch (e) {// ignore if cannot parse as JSON
  }

  return value;
}

exports.parseValue = parseValue;
exports.default = new LocalStorage();